import { render, staticRenderFns } from "./SidebarLayout.vue?vue&type=template&id=5949ebca&scoped=true&"
import script from "./SidebarLayout.vue?vue&type=script&lang=js&"
export * from "./SidebarLayout.vue?vue&type=script&lang=js&"
import style0 from "./SidebarLayout.vue?vue&type=style&index=0&id=5949ebca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5949ebca",
  null
  
)

export default component.exports